import { createRouter, createWebHashHistory } from 'vue-router'
import ColorExtractor from '../views/ColorExtractor.vue'
import { analytics } from '../utils/analytics'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: ColorExtractor
    }
  ]
})

// 路由变化时跟踪页面访问
router.afterEach((to, from) => {
  // 等待analytics初始化完成
  if (analytics.initialized) {
    analytics.trackPageView(to.path, to.name as string)
  }
})

export default router
